import httpService from '../../service/httpService'
import { EditModes } from '../types/IEditModes'
import { toast } from 'react-toastify'

type crudHelperSetting = {
    url: string
    data?: any
    mode: EditModes ;
    key?: string 
    onSuccess?(response: any): void
    onError?(error: any): void,
    label?: string,
    showMessage?: boolean
}

export const HttpGet = (url:string, success: any, error?: any) => {
    crudHelper({
        mode: EditModes.Read,
        url: url,
        onSuccess: (response) => { if (success) success(response) },
        onError: (reponse) => { if (error) error(reponse) }
    })
}

export const HttpPost = (url: string, data: any, success: any, error?: any) => {
    crudHelper({
        mode: EditModes.Create,
        url: url,
        data: data,
        onSuccess: (response) => { if (success) success(response) },
        onError: (reponse) => { if (error) error(reponse) }
    })
}

export const HttpPut = (url: string, data: any, success: any, error?: any) => {
    crudHelper({
        mode: EditModes.Update,
        url: url,
        data: data,
        onSuccess: (response) => { if (success) success(response) },
        onError: (reponse) => { if (error) error(reponse) }
    })
}

export const HttpDelete = (url: string, data: any, success: any, error?: any) => {
    crudHelper({
        mode: EditModes.Delete,
        url: url,
        onSuccess: (response) => { if (success) success(response) },
        onError: (reponse) => { if (error) error(reponse) }
    })
}

export const crudHelper = (settings: crudHelperSetting) => {

    const Messages = {
        CreateSuccess: `Successfully Saved !`,
        CreateError: `Please Try again !`,
        ReadSuccess: '',
        ReadError: '',
        UpdateSuccess: 'Successfully Updated !',
        UpdateError: 'Update Error',
        DeleteSuccess: 'Successfully Deleted !',
        DeleteError: 'Delete Error',
    }

    var url = settings.url ;
    if (settings.mode !== EditModes.Read && settings.mode !== EditModes.Update && settings.key === "") {
        url += "/" + settings.key;
    }

    switch (settings.mode) {
        case EditModes.Read:
                httpService
                    .get(url )
                    .then((response) => {
                        if (settings.onSuccess) settings.onSuccess(response);
                        if (settings.showMessage && Messages.ReadSuccess) toast.success(Messages.ReadSuccess);
                    }).catch(error => {
                        if (settings.onError) settings.onError(error)
                        if (settings.showMessage && Messages.ReadError) toast.warn(Messages.ReadError);
                    });
            break;

        case EditModes.Create:
            httpService
                .post(url, settings.data)
                .then(response => {
                    if (settings.onSuccess) settings.onSuccess(response);
                    if (settings.showMessage && Messages.CreateSuccess) toast.success(Messages.CreateSuccess);
                })
                .catch(error => {
                    if (settings.onError) settings.onError(error)
                    if (settings.showMessage && Messages.CreateError) toast.warn(Messages.CreateError);
                });
            break;

        case EditModes.Update:
                httpService
                    .put(url, settings.data)
                    .then(response => {
                        if (settings.onSuccess) settings.onSuccess(response);
                        if (settings.showMessage && Messages.UpdateSuccess) toast.success(Messages.UpdateSuccess);
                    })
                    .catch(error => {
                        if (settings.onError) settings.onError(error)
                        if (settings.showMessage && Messages.UpdateError) toast.warn(Messages.UpdateError);
                    });
            break;

        case EditModes.Delete:
                httpService
                    .delete(url)
                    .then(response => {
                        if (settings.onSuccess) settings.onSuccess(response);
                        if (settings.showMessage && Messages.DeleteSuccess) toast.success(Messages.DeleteSuccess);
                    })
                    .catch(error => {
                        if (settings.onError) settings.onError(error)
                        if (settings.showMessage && Messages.DeleteError) toast.warn(Messages.DeleteError);
                    });
            break;
    }
}
